import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { LoadingButton } from '@mui/lab';
import { memo } from 'react';
import type { SearchTableHeaderButtonProps as Props } from './types';

export const SearchTableHeaderButton = memo(
  ({ className, text, icon, compact, disabled, ...other }: Props) => {
    return (
      <LoadingButton
        size="small"
        startIcon={
          icon && (
            <Icon className={classnames({ disabled })} name={icon} size={20} />
          )
        }
        className={classnames('SearchTableHeaderButton', className)}
        {...other}
      >
        {!compact && text}
      </LoadingButton>
    );
  }
);

SearchTableHeaderButton.displayName = 'SearchTableHeaderButton';
